import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { Box, Typography, Grid2 } from "@mui/material";

import PointSolidSheet from '../components/PointSolidSheet';
import ReadyStart from '../screens/ReadyStart';
import SheetPoint from '../components/SheetPoint';
import SupportingOrganizations from '../screens/SupportingOrganizations';

import Colors from "../assets/color";
import BlockInfo from "../components/BlockInfo";

import CarChargedIcon from "../assets/icons/charged-car.svg";
import ChargedStationIcon from "../assets/icons/charge-station.svg";
import LeafIcon from "../assets/icons/leaf-icon.svg";

import PeopleIcon from "../assets/icons/people.svg";
import VehicleIcon from "../assets/icons/vehicle.svg";
import ApartmentIcon from "../assets/icons/apartment.svg";

const usersDescription = [
  {
    title: "Drivers",
    description: "We analyze how drivers move, charge, and plan trips to reduce time, cost, and stress turning every route into a more efficient journey.",
    img: "platform_for_all_1.jpg"
  },
  {
    title: "Host Economics",
    description: "We model utilization, energy costs, and payouts to make hosting profitable, predictable, and sustainable.",
    img: "platform_for_all_2.png"

  },
  {
    title: "Grid Impact",
    description: "We measure carbon savings, grid resilience, and clean energy adoption to ensure every connection strengthens local communities.",
    img: "platform_for_all_3.png"
  },
  {
    title: "Continuous Validation",
    description: "From pilots to surveys to live data experiments, we evolve with our users and the energy ecosystem never standing still..",
    img: "platform_for_all_4.jpg"
  },
]

function AboutSplitev() {
  return (
    <>
      {/* HEADER HERE */}
      <NavBar />

      {/* HERO SECTION */}
      <Box sx={{
        padding: "6.4rem 0",
        background: 'black',
      }}>

        {/* HERO SECTION HERE */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: 'column', sm: 'column', md: 'row' },
            gap: { xs: "7rem", sm: "10rem" },
            justifyItems: "space-between",
            alignItems: "center",
            width: "100%",
            maxWidth: "128rem",
            margin: { xs: "10rem auto", sm: "12rem auto" },
            my: { xs: '5rem', md: '10rem' },
            px: { xs: '2rem', sm: '2rem', md: '6.4rem', lg: '6.4rem' },
          }}>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "center", md: "left" },
              gap: { xs: "1rem", sm: "3rem" },
              mt: { xs: '0rem', md: '4rem' },
              height: "fit-content",
              width: { xs: "100%", md: "50%" }
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '5rem', sm: '7.2rem' },
                fontWeight: 700,
                lineHeight: { xs: '5rem', sm: '5.7rem' },
                maxWidth: '20ch',
                textAlign: { xs: 'left' }
              }}
            >
              About SplitEV
            </Typography>

            <Typography
              sx={{
                color: "littleWhite",
                fontSize: { xs: '1.4rem', sm: '1.8rem' },
                fontWeight: 400,
                lineHeight: { xs: '1.8rem', sm: '2rem' },
                maxWidth: '40ch',
                textAlign: { xs: 'left' }
              }}
            >
              A smarter, accessible, and community-driven charging network across the globe.
            </Typography>
          </Box>

          <Box
            sx={{
              position: "relative",
              height: { xs: "40rem", sm: "65rem" },
              borderRadius: "2.5rem",
              overflow: "hidden",
              width: { xs: "100%", md: "50%" }
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundImage: `url(${require('../assets/images/splitev-about-hero.png')})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top',
                backgroundOrigin: 'top',
              }}
            ></Box>
          </Box>
        </Box>

        {/* SUPPORTING ORGANIZATIONS */}
        <SupportingOrganizations />
      </Box>

      {/* ABOUT CONTENT HERE */}
      <Box sx={{
        padding: "6.4rem 0",
        background: 'black',
        px: { xs: '2rem', sm: '2rem', md: '6.4rem', lg: '6.4rem' },
      }}>

        {/* WHO ARE WE SECTION */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          gap: { xs: "7rem", sm: "10rem" },
          justifyItems: "space-between",
          alignItems: "center",
          width: "100%",
          maxWidth: "128rem",
          margin: { xs: "10rem auto", sm: "12rem auto" },
          my: { xs: '5rem', md: '18rem' },
        }}>

          <Box
            data-aos="flip-down"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            sx={{
              position: "relative",
              width: { xs: '100%', sm: "40rem", md: "64rem" },
              height: { xs: "40rem", sm: "64rem" },
              borderRadius: "2.5rem",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundImage: `url(${require('../assets/images/who-we-are-splitev-1.jpg')})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top',
                backgroundOrigin: 'top',
              }}
            ></Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "center", md: "left" },
              gap: "3.2rem",
              mt: { xs: '0rem', md: '4rem' }
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '3.4rem', sm: '4.6rem' },
                fontWeight: 700,
                lineHeight: { xs: '5rem', sm: '5.7rem' },
                maxWidth: '24ch',
                textAlign: { xs: 'left' }
              }}
            >
              Who we are
            </Typography>

            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
              <Box
                sx={{
                  listStyle: "none",
                  color: "paleWhite",
                  display: "flex",
                  flexDirection: "column",
                  gap: "2rem"
                }}
                component="ol"
              >
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  At SplitEV, we believe the future of clean mobility is built together. Drivers, hosts, developers,
                  and innovators are united by a shared mission: to make EV charging accessible,
                  affordable, and available everywhere it’s needed.
                </Box>

                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  We connect the millions of private chargers already embedded in our homes and cities into a single,
                  intelligent network, turning everyday infrastructure into shared opportunity.
                </Box>

                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  We’re not waiting for the future of clean mobility to be built from the top down.
                  We’re building it from the ground up — open, distributed, and powered by people.
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Our Vision */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          gap: { xs: "7rem", sm: "10rem" },
          justifyItems: "space-between",
          alignItems: "center",
          width: "100%",
          maxWidth: "128rem",
          margin: { xs: "10rem auto", sm: "12rem auto" },
          my: { xs: '5rem', md: '18rem' },
        }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "center", md: "left" },
              gap: "3.2rem",
              mt: { xs: '0rem', md: '4rem' }
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '3.4rem', sm: '4.6rem' },
                fontWeight: 700,
                lineHeight: { xs: '5rem', sm: '5.7rem' },
                maxWidth: '24ch',
                textAlign: { xs: 'left' }
              }}
            >
              Our Vision
            </Typography>

            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
              <Box
                sx={{
                  listStyle: "none",
                  color: "paleWhite",
                  display: "flex",
                  flexDirection: "column",
                  gap: "2rem"
                }}
                component="ol"
              >
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  SplitEV is building the world’s most inclusive charging network by connecting communities across continents, from Lagos to São Paulo to Shanghai.
                </Box>

                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  We want to make electric mobility universal by transforming local infrastructure into global connection.Together,
                  we’re democratizing clean mobility — one charger, one neighborhood, one nation at a time.
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            data-aos="flip-down"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            sx={{
              position: "relative",
              width: { xs: '100%', sm: "40rem", md: "64rem" },
              height: { xs: "40rem", sm: "64rem" },
              borderRadius: "2.5rem",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundImage: `url(${require('../assets/images/splitev-globe.jpg')})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'left',
                backgroundOrigin: 'center',
              }}
            ></Box>
          </Box>
        </Box>

        {/* WHY SPLITEV */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          gap: { xs: "7rem", sm: "10rem" },
          justifyItems: "space-between",
          alignItems: "center",
          width: "100%",
          maxWidth: "128rem",
          margin: { xs: "10rem auto", sm: "12rem auto" },
          my: { xs: '5rem', md: '18rem' },
        }}>

          <Box
            data-aos="flip-down"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            sx={{
              position: "relative",
              width: { xs: '100%', sm: "40rem", md: "64rem" },
              height: { xs: "40rem", sm: "64rem" },
              borderRadius: "2.5rem",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundImage: `url(${require('../assets/images/charger-side-view.jpg')})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'left',
                backgroundOrigin: 'center',
              }}
            ></Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "center", md: "left" },
              gap: "3.2rem",
              mt: { xs: '0rem', md: '4rem' }
            }}
          >
            <Typography
              sx={{
                color: "toughGrey",
                fontSize: '1.6rem',
                fontWeight: 500,
                width: 'fit-content',
              }}
            >
              BENEFITS
            </Typography>

            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '3.4rem', sm: '4.6rem' },
                fontWeight: 700,
                lineHeight: { xs: '5rem', sm: '5.7rem' },
                maxWidth: '24ch',
                textAlign: { xs: 'left' }
              }}
            >
              Why SplitEV
            </Typography>

            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
              <Box
                sx={{
                  listStyle: "none",
                  color: "paleWhite",
                  display: "flex",
                  flexDirection: "column",
                  gap: "2rem"
                }}
                component="ol"
              >
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  The future of mobility is electric, but the infrastructure hasn’t caught up.
                  SplitEV was built to unlock what already exists — the millions of private chargers in our homes and
                  neighborhoods — and turn them into a shared network that makes EV charging accessible, reliable, and community-driven.
                </Box>

                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  With SplitEV, everyone benefits. Drivers get dependable, affordable charging anywhere.
                  Hosts earn passive income and become visible leaders in clean energy.
                  Communities strengthen local access and resilience instead of relying on slow, centralized buildouts.
                  SplitEV turns the world’s idle chargers into the most distributed energy network ever built — one connection at a time.
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* How SplitEV works SECTION */}
        <Box
          sx={{
            display: "flex",
            overflow: "hidden",
            m: "auto",
            my: { xs: '5rem', md: '18rem' },
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: "100%",
            maxWidth: "115rem",
          }}>

          <Box
            sx={{
              alignItems: 'center',
              justifyContent: 'center', textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: '3.6rem', sm: '4.2rem', md: '4.6rem' },
                fontWeight: 700,
                my: { xs: '2rem', sm: '2.4rem' },
                m: 'auto',
                lineHeight: '4.5rem',
                width: { xs: '90%', md: '100%' }
              }}
            >
              How SplitEV works
            </Typography>

            <Typography
              sx={{
                color: "rgba(255, 255, 255, 0.75)",
                fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' },
                fontWeight: 400,
                m: 'auto',
                lineHeight: '2.2rem',
                width: { xs: '90%', md: '100%' },
                mb: { xs: "1rem", md: "4rem" },
                maxWidth: "70ch"
              }}
            >
              SplitEV allows homeowners, businesses, and fleet operators to share their private chargers with EV drivers,
              creating an integrated, decentralized network that expands charging access without the need for costly infrastructure projects.
            </Typography>
          </Box>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              width: "100%",
              display: { xs: "flex", sm: "grid" },
              flexDirection: "column",
              gridTemplateColumns: "repeat(auto-fit, minmax(45rem, 1fr))",
              gap: "5rem",
              justifyContent: "start",
              my: "4rem",
            }}
          >
            <Box component="li">
              <PointSolidSheet
                image={CarChargedIcon}
                title="EV Drivers"
              >
                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    // margin: "auto",
                    gap: "5rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box component="li"
                    sx=
                    {{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4rem",
                    }}>
                    <SheetPoint
                      smallTitle="How SplitEV Helps"
                      smallTitleText='Affordable, reliable charging without long wait times'>
                    </SheetPoint>

                    <SheetPoint
                      smallTitle="Impact"
                      smallTitleText='Eliminates range anxiety and high-cost public charging'>
                    </SheetPoint>
                  </Box>
                </Box>
              </PointSolidSheet>
            </Box>

            <Box component="li">
              <PointSolidSheet
                image={ChargedStationIcon}
                title="Homeowners & Hosts"
              >
                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    gap: "5rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box component="li"
                    sx=
                    {{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4rem",
                    }}>
                    <SheetPoint
                      smallTitle="How SplitEV Helps"
                      smallTitleText='Earn passive income by sharing their charger'>
                    </SheetPoint>

                    <SheetPoint
                      smallTitle="Impact"
                      smallTitleText='Creates new revenue streams while expanding EV infrastructure'>
                    </SheetPoint>
                  </Box>
                </Box>
              </PointSolidSheet>
            </Box>

            <Box component="li">
              <PointSolidSheet
                image={ApartmentIcon}
                title="Local Businesses"
              >
                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    gap: "5rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box component="li"
                    sx=
                    {{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4rem",
                    }}>
                    <SheetPoint
                      smallTitle="How SplitEV Helps"
                      smallTitleText='Attract EV customers with charging incentives'>
                    </SheetPoint>

                    <SheetPoint
                      smallTitle="Impact"
                      smallTitleText='Increases foot traffic and strengthens local economies'>
                    </SheetPoint>
                  </Box>
                </Box>
              </PointSolidSheet>
            </Box>

            <Box component="li">
              <PointSolidSheet
                image={VehicleIcon}
                title="Fleet Operators"
              >
                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    gap: "5rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box component="li"
                    sx=
                    {{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4rem",
                    }}>
                    <SheetPoint
                      smallTitle="How SplitEV Helps"
                      smallTitleText='Predictable, cost-effective charging at strategic locations'>
                    </SheetPoint>

                    <SheetPoint
                      smallTitle="Impact"
                      smallTitleText='Reduces fuel costs and increases efficiency'>
                    </SheetPoint>
                  </Box>
                </Box>
              </PointSolidSheet>
            </Box>

            <Box component="li">
              <PointSolidSheet
                image={PeopleIcon}
                title="Communities in Need"
              >
                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    gap: "5rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box component="li"
                    sx=
                    {{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4rem",
                    }}>
                    <SheetPoint
                      smallTitle="How SplitEV Helps"
                      smallTitleText='Emergency charging in disaster zones or underserved areas'>
                    </SheetPoint>

                    <SheetPoint
                      smallTitle="Impact"
                      smallTitleText='Provides reliable access where traditional infrastructure lacks'>
                    </SheetPoint>
                  </Box>
                </Box>
              </PointSolidSheet>
            </Box>

            <Box component="li">
              <PointSolidSheet
                image={LeafIcon}
                title="The Environment"
              >
                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    gap: "5rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box component="li"
                    sx=
                    {{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4rem",
                    }}>
                    <SheetPoint
                      smallTitle="How SplitEV Helps"
                      smallTitleText='Supports clean energy & EV adoption'>
                    </SheetPoint>

                    <SheetPoint
                      smallTitle="Impact"
                      smallTitleText='Reduces carbon emissions and promotes sustainability'>
                    </SheetPoint>
                  </Box>
                </Box>
              </PointSolidSheet>
            </Box>
          </Box>
        </Box>

        {/* OUR RESEARCH APPROACH SECTION */}
        <Box
          id="use-case"
          sx={{
            p: { xs: '64px 20px', sm: '64px 40px', md: '112px 64px' },
            backgroundColor: 'black',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: "center",
            gap: { xs: '1rem', md: '2rem' },
          }}
        >
          <Typography
            sx={{
              color: Colors.white,
              fontFamily: 'mulish',
              fontSize: { xs: '36px', sm: '42px', md: '48px' },
              fontWeight: 800,
              lineHeight: { xs: '3.5rem', sm: '4rem', md: '5rem' },
            }}
          >
            Our research approach
          </Typography>

          <Typography
            sx={{
              color: "rgba(255, 255, 255, 0.75)",
              fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' },
              fontWeight: 400,
              m: 'auto',
              lineHeight: '2.2rem',
              width: { xs: '90%', md: '100%' },
              mb: { xs: "1rem", md: "4rem" },
              maxWidth: "70ch"
            }}
          >
            At SplitEV, our research connects data science with human insight to design charging experiences that are smarter, fairer, and built for scale.
          </Typography>

          <Grid2 container spacing={{ xs: 8, md: 1 }}
            component="ul"
            sx={{
              listStyle: 'none',
              maxWidth: "150rem",
              margin: { xs: "4rem auto", sm: "2rem auto" },
            }}
          >
            {usersDescription.map((user) =>
              <Box
                component="li"
                sx={{
                  width: { xs: '100%', md: 'inherit' },
                  display: 'flex',
                  justifyContent: 'center',
                  ":last-child > hr": { display: 'none' },
                  "> hr": { display: { xs: 'none', md: 'flex' } }
                }}
                key={user.title}
              >
                <Box sx={{}}>
                  <BlockInfo
                    title={user.title}
                    description={user.description}
                    img={user.img}
                    action={user.action}>
                  </BlockInfo>
                </Box>

                <Box component="hr" sx={{ mx: '1.5rem' }} />
              </Box>
            )}
          </Grid2>
        </Box >
      </Box >

      {/* FOOTER SECTION */}
      <ReadyStart
        phrase="The future of charging starts with you"
        subtitle="The future of mobility starts with us. Every driver, host, and partner moves the world closer to sustainable energy.">
      </ReadyStart>
      < Footer />
    </>
  );
}

export default AboutSplitev;